/**
 * Deferred Action Queue Utility
 *
 * A general-purpose utility to hold queued actions (callbacks) until
 * a specific initialization phase or event occurs.
 *
 * Use cases: delay tracking events until feature flags are ready,
 * delay API calls until auth is initialized, etc.
 */

const QUEUE_LIMIT = 100
const queues = {}

/**
 * Adds an action to a specific queue bucket if the limit has not been reached.
 *
 * @param {string} queueName - The name of the bucket (e.g. 'mixpanel_anonymous')
 * @param {Function} action - The callback to execute later
 */
export const pushToQueue = (queueName, action) => {
  if (!queueName || typeof action !== 'function') return

  if (!queues[queueName]) {
    queues[queueName] = []
  }

  if (queues[queueName].length < QUEUE_LIMIT) {
    queues[queueName].push(action)
  }
}

/**
 * Executes all actions in the specified queue bucket and clears it.
 *
 * @param {string} queueName - The name of the bucket to flush
 */
export const flushQueue = (queueName) => {
  const queue = queues[queueName]
  if (!queue || queue.length === 0) return

  while (queue.length > 0) {
    const action = queue.shift()
    if (typeof action === 'function') {
      try {
        action()
      } catch (e) {
        // Silently ignore errors to ensure the rest of the queue is processed
      }
    }
  }
}
